// @flow

import { decimalFormatter } from '@tectonics/look-and-feel/commons/format-utils';
import { type Country } from '@tectonics/prs/country';
import { type CurrencyCode, type FormatDecimal } from '@tectonics/prs/money';

const DOLLAR_FORMAT = decimalFormatter({
  thousandsSeparator: ',',
  decimalSeparator: '.',
});

const LATAM_FORMAT = decimalFormatter({
  thousandsSeparator: '.',
  decimalSeparator: ',',
});

export function getMoneyFormat(country: Country): FormatDecimal {
  switch (country) {
    case 'mx':
    case 'za':
    case 'ke':
    case 'eg':
    case 'ng':
    case 'in':
      return DOLLAR_FORMAT;
    default:
      return LATAM_FORMAT;

  }
}

export function getMoneyFormatFromCurrency(currencyCode: CurrencyCode): FormatDecimal {
  switch (currencyCode) {
    case 'USD':
    case 'ZAR':
    case 'KES':
      return DOLLAR_FORMAT;
    default:
      return LATAM_FORMAT;
  }
}
